import React from 'react';

const TaxonomyArchive = ({taxonomy, terms = []}) =>
    <>
        <h1>{taxonomy}</h1>
        {terms.map(({name, description, archive_permalink}, idx) =>
            <div key={idx}>
                <h1><a href={archive_permalink}>{name}</a></h1>
                <p>{description}</p>
            </div>
        )}
    </>;

export default TaxonomyArchive;

